<template>
    <div class="px-4">
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                v-if="hotspotDescription"
                cols="12"
                class="pb-2"
            >
                <span
                    class="description habiteo-body-1 overflow-ellipsis"
                    v-html="hotspotDescription"
                />
            </v-col>
            <v-col
                v-if="plotCategory"
                cols="12"
                class="pb-2"
            >
                <span
                    class="font-weight-bold global-nav"
                    v-html="plotCategory.value"
                />
            </v-col>
            <v-col
                v-if="plotDescription && showPlotInformation"
                class="truncated-description pb-2"
                cols="12"
            >
                <span
                    class="habiteo-body-1"
                    v-html="plotDescription.value"
                />
            </v-col>
        </v-row>
        <v-row
            v-if="filteredPlotDetails.length"
            no-gutters
        >
            <v-col cols="12">
                <ul :style="{ 'width': width}">
                    <li
                        v-for="(plotDetail, index) in filteredPlotDetails"
                        :key="`plot-detail-${index}`"
                        class="pb-2"
                    >
                        <span
                            class="plot-card-detail habiteo-body-1 text-none"
                            v-html="getDetailText(plotDetail)"
                        />
                    </li>
                </ul>
            </v-col>
        </v-row>
        <v-row
            v-if="plotAvailability"
            no-gutters
            class="mt-5"
        >
            <v-col cols="12">
                <span
                    class="availability-text"
                    v-html="plotAvailability.value"
                    :style="{'color': plotAvailability.color}"
                />
            </v-col>
        </v-row>
        <v-row v-if="itineraryInformation">
            <v-col cols="12">
                <span
                    class="habiteo-body-2 grey-text float-right"
                    v-html="itineraryInformation"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: 'Details',
        props: {
            details: {
                type: Array,
                required: true
            },
            width: {
                type: [Number, String],
                required: true
            },
            screenProperties: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                detaislList: [
                    'surface',
                    'exposition',
                    'level'
                ],
                hideOnSmallScreen: [
                    'description'
                ]
            }
        },
        computed: {
            filteredPlotDetails() {
                return this.$props.details ? this.$props.details.filter(plotDetail => this.detaislList.includes(plotDetail.id) && plotDetail.value != '') : null;
            },
            plotCategory() {
                return this.$props.details ? this.getPlotDetailById('category') : null;
            },
            plotAvailability() {
                return this.$props.details ? this.getPlotDetailById('availability') : null;
            },
            plotDescription() {
                return this.$props.details ? this.getPlotDetailById('description') : null;
            },
            hotspotDescription() {
                return this.$props.type === 'hotspot' && this.$props.details.length ? this.$props.details[0].value : null;
            },
            itineraryInformation() {
                return this.$props.type === 'hotspot' && this.$props.details.length > 1 ? this.$props.details[1].value : null;
            },
            showPlotInformation() {
                return !this.screenProperties.isSmallScreen && !this.screenProperties.isTinyScreen;
            }
        },
        methods: {
            getPlotDetailById(detailId) {
                let detail = this.$props.details.filter(plotDetail => plotDetail.id === detailId);
                if (detail.length)
                    return detail[0];
                else
                    return null;
            },
            getDetailText(detail) {
                switch (detail.id) {
                    case "level":
                        return detail.value;

                    case "surface":
                        return detail.label + ' ' + detail.value + ' ' + detail.unit;

                    default:
                        return detail.label + ' ' + detail.value;
                }
            }
        }
    }
</script>

<style lang="scss">
    .truncated-description {
        height: 50px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        p {
            font-size: .75rem;
            > * {
                font-size: .75rem;
            }
        }
        a {
            color: black;
        }
    }

    .availability-text {
        font-weight: 800;
    }
</style>


// WEBPACK FOOTER //
// src/components/plotInformation/components/Details.vue